var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "FormTitle",
        {
          staticClass: "pa-4 pt-0",
          attrs: { dark: "" },
          scopedSlots: _vm._u([
            {
              key: "subtitle",
              fn: function () {
                return [
                  _vm._v(
                    "Seven questions, multiple choice, no writing if you don’t want\n            to. When you're done, we have a "
                  ),
                  _c("b", [_vm._v("special gift")]),
                  _vm._v(" for you!\n        "),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v("Musicologie Student Experience Survey\n        ")]
      ),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [
                _vm._v("\n            How likely are you to recommend "),
                _c("u", [_vm._v("Musicologie")]),
                _vm._v(" to a\n            friend or colleague?\n        "),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("NPSOptions", {
                  attrs: {
                    "error-messages": _vm.errors.recommend_us,
                    rules: _vm.rules_required,
                  },
                  model: {
                    value: _vm.form.recommend_us,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "recommend_us", $$v)
                    },
                    expression: "form.recommend_us",
                  },
                }),
                _vm._v(" "),
                _vm.form.recommend_us !== null && _vm.form.recommend_us < 8
                  ? _c("v-textarea", {
                      attrs: {
                        label: "What's the reason for this score?",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        rules: _vm.rules_text_limit,
                        counter: "",
                        maxlength: "255",
                      },
                      model: {
                        value: _vm.form.recommend_us_reason,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "recommend_us_reason", $$v)
                        },
                        expression: "form.recommend_us_reason",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.recommend_us >= 8
                  ? _c(
                      "div",
                      {
                        staticClass: "soli-grey text-start",
                        staticStyle: { display: "block" },
                      },
                      [
                        _vm._v("\n                Awesome!\n                "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://musicologielessons.com/review",
                              target: "_blank",
                            },
                          },
                          [_vm._v("Go here to review us")]
                        ),
                        _vm._v(
                          ". It just takes 30 seconds and won't mess up this form.\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [
                _vm._v("\n            How likely are you to recommend "),
                _c("u", [_vm._v("your teacher")]),
                _vm._v(
                  _vm._s(`${_vm.teacher ? `, ${_vm.teacher.name},` : ""}`) +
                    " to a friend or\n            colleague?\n        "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("NPSOptions", {
                  attrs: {
                    "error-messages": _vm.errors.recommend_teacher,
                    rules: _vm.rules_required,
                  },
                  model: {
                    value: _vm.form.recommend_teacher,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "recommend_teacher", $$v)
                    },
                    expression: "form.recommend_teacher",
                  },
                }),
                _vm._v(" "),
                _vm.form.recommend_teacher !== null &&
                _vm.form.recommend_teacher < 8
                  ? _c("v-textarea", {
                      attrs: {
                        label: "What's the reason for this score?",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        rules: _vm.rules_text_limit,
                        counter: "",
                        maxlength: "255",
                      },
                      model: {
                        value: _vm.form.recommend_teacher_reason,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "recommend_teacher_reason", $$v)
                        },
                        expression: "form.recommend_teacher_reason",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v("Where did you first hear about Musicologie?")]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-0",
                    attrs: {
                      rules: _vm.rules_required,
                      errors: _vm.errors.hear_about_us,
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.form.hear_about_us,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hear_about_us", $$v)
                      },
                      expression: "form.hear_about_us",
                    },
                  },
                  _vm._l(_vm.hearAboutUsOptions, function (option, idx) {
                    return _c("v-radio", {
                      key: idx,
                      attrs: { label: option, value: option },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.form.hear_about_us == "From another business" ||
                _vm.form.hear_about_us == "At an event"
                  ? _c("SoliText", {
                      staticClass: "pt-3",
                      attrs: {
                        label: `Which ${
                          _vm.form.hear_about_us.includes("business")
                            ? "business"
                            : "event"
                        }?`,
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        rules: _vm.rules_string_limit,
                        counter: "",
                        maxlength: "75",
                      },
                      model: {
                        value: _vm.form.hear_about_us_detail,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "hear_about_us_detail", $$v)
                        },
                        expression: "form.hear_about_us_detail",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.hear_about_us == "Other"
                  ? _c("SoliText", {
                      staticClass: "pt-3",
                      attrs: {
                        label: "Where?",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        rules: _vm.rules_string_limit,
                        counter: "",
                        maxlength: "75",
                      },
                      model: {
                        value: _vm.form.hear_about_us_other,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "hear_about_us_other", $$v)
                        },
                        expression: "form.hear_about_us_other",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [
                _vm._v("Which three of the following things are "),
                _c("u", [_vm._v("MOST")]),
                _vm._v(" important\n            for you in your lessons?"),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c(
                  "v-input",
                  {
                    attrs: {
                      rules: [
                        (val) =>
                          val.length <= 3 || "Please select only three items",
                      ],
                      value: _vm.form.most_important,
                      "error-messages": _vm.errors.most_important,
                      "hide-details": "auto",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      _vm._l(_vm.importantOptions, function (option, idx) {
                        return _c(
                          "div",
                          { key: idx },
                          [
                            _c("v-checkbox", {
                              staticClass: "mt-0 mb-1",
                              attrs: {
                                label: option,
                                value: option,
                                "hide-details": "auto",
                              },
                              model: {
                                value: _vm.form.most_important,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "most_important", $$v)
                                },
                                expression: "form.most_important",
                              },
                            }),
                            _vm._v(" "),
                            _vm.form.most_important.includes(
                              "Achieving a specific goal"
                            ) &&
                            idx ==
                              _vm.importantOptions.indexOf(
                                "Achieving a specific goal"
                              )
                              ? _c("SoliText", {
                                  staticClass: "pt-3",
                                  attrs: {
                                    label: "What is that goal?",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    rules: _vm.rules_string_limit,
                                    counter: "",
                                    maxlength: "75",
                                  },
                                  model: {
                                    value:
                                      _vm.form.most_important_specific_goal,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "most_important_specific_goal",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.most_important_specific_goal",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.most_important.includes("Other") &&
                            idx == _vm.importantOptions.indexOf("Other")
                              ? _c("SoliText", {
                                  staticClass: "pt-3",
                                  attrs: {
                                    label: "What is most important?",
                                    outlined: "",
                                    dense: "",
                                    "error-messages":
                                      _vm.errors.most_important_other,
                                    rules: _vm.rules_string_limit,
                                    counter: "",
                                    maxlength: "75",
                                  },
                                  model: {
                                    value: _vm.form.most_important_other,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "most_important_other",
                                        $$v
                                      )
                                    },
                                    expression: "form.most_important_other",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [
                _vm._v(
                  "How well are we delivering those top three things to\n            you?"
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("NPSOptions", {
                  attrs: {
                    "error-messages": _vm.errors.are_we_delivering,
                    rules: _vm.rules_required,
                    labels: ["Not well", "Very well"],
                  },
                  model: {
                    value: _vm.form.are_we_delivering,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "are_we_delivering", $$v)
                    },
                    expression: "form.are_we_delivering",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: { required: "" },
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [
                _vm._v("Which three of the following things are "),
                _c("u", [_vm._v("LEAST")]),
                _vm._v(" important\n            for you in your lessons?"),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c(
                  "v-input",
                  {
                    ref: "least_important",
                    attrs: {
                      rules: [
                        (val) =>
                          val.length <= 3 || "Please select only three items",
                      ],
                      value: _vm.form.least_important,
                      "error-messages": _vm.errors.least_important,
                      "hide-details": "auto",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      _vm._l(_vm.importantOptions, function (option, idx) {
                        return _c(
                          "div",
                          { key: idx },
                          [
                            _c("v-checkbox", {
                              staticClass: "mt-0 mb-1",
                              attrs: {
                                label: option,
                                value: option,
                                "hide-details": "auto",
                              },
                              model: {
                                value: _vm.form.least_important,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "least_important", $$v)
                                },
                                expression: "form.least_important",
                              },
                            }),
                            _vm._v(" "),
                            _vm.form.least_important.includes(
                              "Achieving a specific goal"
                            ) &&
                            idx ==
                              _vm.importantOptions.indexOf(
                                "Achieving a specific goal"
                              )
                              ? _c("SoliText", {
                                  staticClass: "pt-3",
                                  attrs: {
                                    label: "What is that goal?",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    rules: _vm.rules_string_limit,
                                    counter: "",
                                    maxlength: "75",
                                  },
                                  model: {
                                    value:
                                      _vm.form.least_important_specific_goal,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "least_important_specific_goal",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.least_important_specific_goal",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.least_important.includes("Other") &&
                            idx == _vm.importantOptions.indexOf("Other")
                              ? _c("SoliText", {
                                  staticClass: "pt-3",
                                  attrs: {
                                    label: "What is least important?",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    rules: _vm.rules_string_limit,
                                    counter: "",
                                    maxlength: "75",
                                  },
                                  model: {
                                    value: _vm.form.least_important_other,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "least_important_other",
                                        $$v
                                      )
                                    },
                                    expression: "form.least_important_other",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormItem", {
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v("Anything we could do better?")]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c("v-textarea", {
                  attrs: {
                    placeholder: "You answer",
                    outlined: "",
                    dense: "",
                    "hide-details": "auto",
                    rules: _vm.rules_text_limit,
                    counter: "",
                    maxlength: "255",
                  },
                  model: {
                    value: _vm.form.do_better,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "do_better", $$v)
                    },
                    expression: "form.do_better",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("FormSubmit", {
        attrs: {
          dark: "",
          type: "submit",
          loading: _vm.loading,
          valid: "",
          errors: _vm.errors,
          gradient: "gradient-orange",
          icon: "send",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }